<template>
  <VModal class="modal-wrapper" :color="ColorType.none" :type="ModalType.custom" :isScroll="false">
    <VCard :radiusArray="[15, 15, 0, 0]">
      <VBlock :direction="Direction.column">
        <VBlock :direction="Direction.column" :sort="Sort.center_center" class="reservation-header">
          <VSpan text="나중에 받기" :weight="TextWeight.bold" :size="14" />
          <VSpan text="배달 받을 시간을 선택해주세요" :color="TextColor.gray2" :size="12" />
        </VBlock>
        <VBlock :direction="Direction.column" class="reservation-contents">
          <VBlock class="top-gradient"></VBlock>
          <!-- TODO 예약 불가능한 시간대 처리 -->
          <!-- FIXME active 한 엘리먼트 필터링하지 않고 dim 처리  -->
          <ConfirmButtonList
            ref="scrollLayer"
            :list="params.deliveryReservation.options.filter(e => e.active).map(e => `${e.from} ~ ${e.to}`)"
            name="delivery-reservation"
            :state="radioButtonListState"
            :onClick="setReservation"
            :width="24"
            :height="24"
          />
          <VBlock class="bottom-gradient"></VBlock>
        </VBlock>
        <VBlock class="reservation-footer" :sort="Sort.center_center">
          <VButton class="footer-button" :onClick="onCancel">
            <VBlock :sort="Sort.center_center">
              <VSpan text="닫기" :size="16" />
            </VBlock>
          </VButton>
          <VButton class="footer-button" :onClick="doReservation">
            <VBlock :sort="Sort.center_center">
              <VSpan text="선택" :weight="TextWeight.bold" :size="16" />
            </VBlock>
          </VButton>
        </VBlock>
        <VBlock class="footer-notch">
          <VBlock class="middle-line"></VBlock>
          <VBlock class="middle-line-overlay"></VBlock>
        </VBlock>
      </VBlock>
    </VCard>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VHR from '@/presentationals/v2/components/layouts/atoms/VHR'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VCard, { ColorType } from '@/presentationals/v2/components/layouts/molecules/VCard'
import VModal, { ModalType } from '@/presentationals/v2/components/layouts/molecules/VModal'
import VA from '../../molecules/VA/index'

import ConfirmButtonList from '@/presentationals/v2/components/layouts/organisms/ConfirmButtonList'

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default {
  name: 'ModalDeliveryReservation',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      required: true
    }
  },
  components: {
    VA,
    VButton,
    VSpan,
    VHR,

    VBlock,
    VCard,
    VModal,

    ConfirmButtonList
  },
  computed: {
    radioButtonListState() {
      return `${this.state.from} ~ ${this.state.to}`
      // return this.state
    }
  },
  mounted() {
    disableBodyScroll(this.$refs.scrollLayer.$el)
  },
  beforeDestroy() {
    enableBodyScroll(this.$refs.scrollLayer.$el)
  },
  destroyed() {
    this.onCancel()
  },
  methods: {
    doReservation() {
      this.params.onDeliveryReservation({
        use: true,
        selected: this.state
      })

      this.onOK()
    },

    setReservation(description) {
      const reservationId = this.params.deliveryReservation.options.findIndex(
        option => `${option.from} ~ ${option.to}` === description
      )

      this.state = this.params.deliveryReservation.options[reservationId]
    }
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ModalType,
      ColorType,

      // state: '22:00 ~ 22:30'
      state:
        Object.getOwnPropertyNames(this.params.deliveryReservation.selected).length > 1
          ? this.params.deliveryReservation.selected
          : this.params.deliveryReservation.options[0]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.modal-wrapper {
  position: absolute;
  bottom: 0;
  width: auto;
  height: auto;

  .reservation-header {
    padding: 11px 0 6px 0;
    border-bottom: 1px solid $background-gray;
  }

  .reservation-contents {
    position: relative;
    // padding: 18px 15px 0 15px;
    box-sizing: border-box;
    width: 100vw;
    min-height: 80px;
    height: auto;

    .top-gradient {
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 0 20px 0;
      width: 100%;
      z-index: 3;
      background: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
      background: -moz-linear-gradient(bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
      background: -webkit-linear-gradient(
        bottom,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 1) 100%
      );
    }

    .bottom-gradient {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 0 0 20px 0;
      width: 100%;
      z-index: 3;
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
      background: -moz-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
      background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
    }
  }

  .reservation-footer {
    .footer-button {
      width: 100%;
      height: 50px;
      padding: 17px 0 14px;
      border-collapse: collapse;
      border-top: 1px solid $light-gray-5;

      &:first-child {
        border-right: 1px solid $light-gray-5;
      }
    }
  }
  .footer-notch {
    position: relative;
    width: 100%;
    height: auto;

    .middle-line {
      width: 1px;
      // height: 50px;
      height: constant(safe-area-inset-bottom);
      height: env(safe-area-inset-bottom);

      border-right: 1px solid $light-gray-5;

      // padding-bottom: constant(safe-area-inset-bottom);
      // padding-bottom: env(safe-area-inset-bottom);
    }

    .middle-line-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
      background: -moz-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
      background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 100%);
    }
  }
}
</style>
